"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackContentboard = exports.initApnListeners = exports.requestBanners = void 0;
var cookie_1 = require("./cookie");
var finn_1 = require("./finn");
var listeners_1 = require("./listeners");
Object.defineProperty(exports, "initApnListeners", { enumerable: true, get: function () { return listeners_1.initApnListeners; } });
Object.defineProperty(exports, "trackContentboard", { enumerable: true, get: function () { return listeners_1.trackContentboard; } });
var takeover_1 = require("./takeover");
Object.defineProperty(exports, "initTakeover", { enumerable: true, get: function () { return takeover_1.initTakeover; } });
Object.defineProperty(exports, "injectTakeoverTemplate", { enumerable: true, get: function () { return takeover_1.injectTakeoverTemplate; } });
Object.defineProperty(exports, "isTakeover", { enumerable: true, get: function () { return takeover_1.isTakeover; } });
function setExternalUid(pageOpts) {
    if (pageOpts) {
        var userId = cookie_1.getAdId();
        pageOpts.user = {};
        pageOpts.user.externalUid = userId;
        if (userId === 'DO_NOT_TRACK') {
            pageOpts.user.dnt = true;
        }
        if (navigator && navigator.doNotTrack === '1') {
            pageOpts.user.dnt = true;
        }
    }
    return pageOpts;
}
function requestBanners(apntag, appNexusData, loadTags, addListeners) {
    if (loadTags === void 0) { loadTags = true; }
    if (addListeners === void 0) { addListeners = true; }
    if (apntag && apntag.anq && appNexusData) {
        apntag.anq.push(function () {
            finn_1.setupFinnGlobalVar(appNexusData);
            var pageOptsWithUserId = setExternalUid(appNexusData.pageOpts);
            apntag.setPageOpts(pageOptsWithUserId);
            if (loadTags) {
                Object.values(appNexusData.tags).forEach(apntag.defineTag);
                apntag.loadTags();
            }
            if (addListeners) {
                listeners_1.initApnListeners(apntag, appNexusData);
            }
        });
    }
}
exports.requestBanners = requestBanners;
